import './fonts.css';
import './index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { QueryProvider } from './api/query/index.tsx';
import { AuthStoreProvider } from './features/auth/store.tsx';
import { ServerMockingProvider } from './features/settings/serverMocking.tsx';
import { Navigation } from './navigation.tsx';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ServerMockingProvider>
      <AuthStoreProvider>
        <QueryProvider>
          <Navigation />
        </QueryProvider>
      </AuthStoreProvider>
    </ServerMockingProvider>
  </StrictMode>,
);
